import { type FC } from 'react';
import GlowImage from '@assets/img/icons/glow.svg?react';
import GreenStarIcon from '@assets/img/icons/green-star.svg?react';
import YellowBlurStarIcon from '@assets/img/icons/yellow-blur-star.svg?react';
import cn from 'classnames';

import { BackgroundWrapper } from '@/components/ui/BackgroundWrapper/BackgroundWrapper';
import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import partnersPng from '/img/bg/partners-bg.png';
import partnersWebp from '/img/bg/partners-bg.webp';

const HeroImage: FC = () => {
  return (
    <div className={cn('w-full h-[320px] relative', css.maskBlack)}>
      <BackgroundWrapper className="bottom-0 right-1/2 translate-x-[45%] w-[17.22rem] h-full">
        <Picture
          img={partnersPng}
          webp={partnersWebp}
          className="w-full h-[11.47rem] absolute bottom-0 left-0 z-[5]"
          alt="partners hero"
        />
        <GreenStarIcon className="absolute bottom-0 left-1/2 -translate-x-[44%] aspect-square w-[14.375rem] z-[2]" />
        <YellowBlurStarIcon className="absolute bottom-[25px] aspect-square w-[11.25rem] left-1/2 -translate-x-[42%] z-[3]" />
        <GlowImage
          className={cn(
            'absolute w-[17.625rem] bottom-[80px] left-[5%]',
            css.maskForGlow,
          )}
        />
        <span className={css.ellipseGradient}></span>
      </BackgroundWrapper>
    </div>
  );
};

export { HeroImage };
